import { createBrowserRouter } from 'react-router-dom';

import { LoginPage, RedirectPage, SignupPage } from '@_pages/auth';
import { CreatePage, DetailPage as ContentDetailPage } from '@_pages/content';
import { ErrorPage } from '@_pages/error';
import { FolderListManualPage, FolderListPage, FolderPage } from '@_pages/folder';
import { MarketingPage } from '@_pages/marketing';
import { NotificationPage } from '@_pages/notification';
import { OnboardingPage, SignupOnboardingPage } from '@_pages/onboarding';
import {
	AnnouncementPage,
	SettingPage,
	AnnouncementDetailPage,
	FeedBackPage,
	TermsPage,
} from '@_pages/settings';
import { EditPage, LeavePage, NicknamePage, LeaveDonePage } from '@_pages/user';

import { AccessDenyLayout } from '@_features/auth';

import { MetaTagWrapper } from '@_shared/ui/MetaTagWrapper';

const router = createBrowserRouter([
	{
		path: '/',
		errorElement: (
			<MetaTagWrapper title="ERROR">
				<ErrorPage />
			</MetaTagWrapper>
		),
		children: [
			{
				path: '',
				element: (
					<MetaTagWrapper title="홈">
						<FolderListPage />
					</MetaTagWrapper>
				),
			},
			{
				path: 'folder',
				element: <AccessDenyLayout />,
				children: [
					{
						path: ':id',
						element: <FolderPage />,
					},
				],
			},
			{
				path: 'folder-list/manual',
				element: <AccessDenyLayout />,
				children: [
					{
						path: '',
						element: <FolderListManualPage />,
					},
				],
			},
			{
				path: 'content',
				element: <AccessDenyLayout />,
				children: [
					{
						path: 'create',
						element: (
							<MetaTagWrapper title="컨텐츠-추가">
								<CreatePage />
							</MetaTagWrapper>
						),
					},
					{
						path: ':id',
						element: (
							<MetaTagWrapper title="컨텐츠-상세보기">
								<ContentDetailPage />
							</MetaTagWrapper>
						),
					},
				],
			},
			{
				path: 'settings',
				element: <AccessDenyLayout />,
				children: [
					{
						path: '',
						element: (
							<MetaTagWrapper title="설정">
								<SettingPage />
							</MetaTagWrapper>
						),
					},
					{
						path: 'announcement',
						element: (
							<MetaTagWrapper title="공지사항">
								<AnnouncementPage />
							</MetaTagWrapper>
						),
					},
					{
						path: 'announcement/:id',
						element: (
							<MetaTagWrapper title="공지사항-상세보기">
								<AnnouncementDetailPage />
							</MetaTagWrapper>
						),
					},
					{
						path: 'feedback',
						element: (
							<MetaTagWrapper title="의견보내기">
								<FeedBackPage />
							</MetaTagWrapper>
						),
					},
				],
			},

			{
				path: 'user',
				element: <AccessDenyLayout />,
				children: [
					{
						path: 'edit',
						children: [
							{
								path: '',
								element: (
									<MetaTagWrapper title="유저-수정">
										<EditPage />
									</MetaTagWrapper>
								),
							},
							{
								path: 'nickname',
								element: (
									<MetaTagWrapper title="유저-닉네임수정">
										<NicknamePage />
									</MetaTagWrapper>
								),
							},
						],
					},
					{
						path: 'leave',
						element: (
							<MetaTagWrapper title="유저-탈퇴">
								<LeavePage />
							</MetaTagWrapper>
						),
					},
					{
						path: 'leave_done',
						element: (
							<MetaTagWrapper title="유저-탈퇴완료">
								<LeaveDonePage />
							</MetaTagWrapper>
						),
					},
				],
			},
			{
				path: 'login',
				element: (
					<MetaTagWrapper title="로그인">
						<LoginPage />
					</MetaTagWrapper>
				),
			},
			{
				path: 'signup',
				element: (
					<MetaTagWrapper title="회원가입">
						<SignupPage />
					</MetaTagWrapper>
				),
			},
			{
				path: '/:type/redirect',
				element: (
					<MetaTagWrapper title="회원가입-리다이렉트">
						<RedirectPage />
					</MetaTagWrapper>
				),
			},
			{
				path: 'notifications',
				element: (
					<AccessDenyLayout>
						<MetaTagWrapper title="알림">
							<NotificationPage />
						</MetaTagWrapper>
					</AccessDenyLayout>
				),
			},
			{
				path: 'onboarding',
				children: [
					{
						path: '',
						element: (
							<MetaTagWrapper title="온보딩">
								<OnboardingPage />
							</MetaTagWrapper>
						),
					},
					{
						path: 'signup',
						element: (
							<AccessDenyLayout>
								<MetaTagWrapper title="회원가입-온보딩">
									<SignupOnboardingPage />
								</MetaTagWrapper>
							</AccessDenyLayout>
						),
					},
				],
			},
			{
				path: 'terms/2',
				element: (
					<MetaTagWrapper title="개인정보이용약관">
						<TermsPage />
					</MetaTagWrapper>
				),
			},
		],
	},
	{
		path: '/ab-test/:group',
		element: <MarketingPage />,
	},
]);

export default router;
